module.exports = __webpack_public_path__ + "img/bar-chart-selected.04404078.svg";